export const TIMER_TYPE_STORAGE_KEY = 'compito.workSession.timerType.v1';
export const POMODORO_STATE_STORAGE_KEY = 'compito.workSession.pomodoroTimer.v1';
export const STOPWATCH_STATE_STORAGE_KEY = 'compito.workSession.stopwatchTimer.v1';

export function readPersistedTimerState(storageKey, expectedVersion = 1) {
    try {
        const storedValue = localStorage.getItem(storageKey);
        if (!storedValue) {
            return null;
        }

        const parsed = JSON.parse(storedValue);
        if (!parsed || parsed.version !== expectedVersion) {
            return null;
        }

        return parsed;
    } catch (error) {
        console.warn(`Failed to parse persisted timer state for ${storageKey}:`, error);
        return null;
    }
}
